var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"left":"","reduce":option => option.key,"options":_vm.options,"searchable":false},model:{value:(_vm.style),callback:function ($$v) {_vm.style=$$v},expression:"style"}})
}
var staticRenderFns = []

export { render, staticRenderFns }